export default defineNuxtPlugin(() => {
  const authStore = useAuthStore()
  const userStore = useUserStore()

  const { $unleash } = useNuxtApp()

  const {
    public: { isExposedHost, http: httpConfig },
  } = useRuntimeConfig()

  // If we are running an exposed dev server, we want to proxy requests so that they are not blocked by CORS
  const prefixUrl = isExposedHost ? '/api' : httpConfig.browserBaseURL

  const route = useRoute()

  const api = $fetch.create({
    baseURL: prefixUrl,
    onRequest({ options }) {
      if (authStore.token.value) {
        const headerValue = `${authStore.authenticationType} ${authStore.token.value}`
        options.headers.set('Authorization', headerValue)
      }

      const unleashSessionId = $unleash.client?.getContext().sessionId
      if (unleashSessionId) {
        options.headers.set('Unleash-Session-Id', unleashSessionId)
      }

      if (options.body && Object.getPrototypeOf(options.body) === Object.prototype) {
        options.headers.set('Content-Type', 'application/json')
      }
    },
    onResponse({ response }) {
      // FIXME: The backend does not provide correct content type headers, so we need to force-parse responses and cannot check for that header here
      if (response.ok && response._data) {
        if (typeof response._data === 'string') {
          try {
            response._data = JSON.parse(response._data)
          } catch {
            // Looks like the response is not JSON, so we don't need to do anything
          }
        }

        if (Object.getPrototypeOf(response._data) === Object.prototype || Array.isArray(response._data)) {
          response._data = objectToCamelCase(response._data)
        }
      }
    },
    onResponseError({ response, options }) {
      if (response?.status && response.status >= 500 && route.name !== 'sorry') {
        // We want to give the server some time to recover and react locally if it doesn't
        if (response.status === 503 || (options.retry && options.retry > 0)) return
        let data = response._data
        if (typeof data === 'string') {
          try {
            data = JSON.parse(data)
          } catch {
            /* not JSON */
          }
        }
        if (data && (Object.getPrototypeOf(data) === Object.prototype || Array.isArray(data))) {
          data = objectToCamelCase(data)
        }
        const requestId = data?.error?.requestId
        navigateTo(requestId ? { path: '/sorry', query: { requestId } } : '/sorry')
      } else if (response?.status === 401) {
        if (route.name !== 'logout' && route.name !== 'login') {
          sessionStorage.setItem('redirectURL', route.fullPath)
        }
        authStore.removeStoredToken()
        void userStore.logoutUser()
      }
    },
  })

  return {
    provide: {
      api,
    },
  }
})
